import NoDataMessage from '../../feedback/NoDataMessage.component';
import { SettingsComponentProps } from '../SettingsRouter.component';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { openingRouteSelector } from '../../../redux/pages/selectors';

export const Forbidden: React.FC<SettingsComponentProps> = () => {
  const navigate = useNavigate();
  const openingRoute = useSelector(openingRouteSelector);

  const handleNavigateToOpeningPage = () => {
    if (openingRoute) {
      navigate(`/${openingRoute}`);
    } else {
      navigate('/');
    }
  };

  return (
    <NoDataMessage
      message="You are unauthorised to view this page. If you think this is a mistake
      please contact RiskSystem support."
    >
      <button
        onClick={handleNavigateToOpeningPage}
        className="inline-flex min-w-[150px] justify-center rounded-md border border-transparent bg-mainblue px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Go to Home
      </button>
    </NoDataMessage>
  );
};
